import type { InputHTMLAttributes, ReactNode } from 'react'

import { cn } from '@/_lib/utils'

import type { UseFormRegisterReturn } from 'react-hook-form'

type Props = {
	error?: string
	registration: UseFormRegisterReturn
	children: ReactNode
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'size' | 'type'>

/**
 * Boomex `.input_checkbox_cont` / consent layout scoped via `.order-flow-checkbox-field`.
 */
export function MCheckbox({ error, registration, children, className, ...rest }: Props) {
	return (
		<div className='order-flow-checkbox-field'>
			<label className={cn('input_checkbox_cont', className)}>
				<input
					type='checkbox'
					className='input_checkbox input_checkbox--dark'
					{...registration}
					{...rest}
				/>
				<span className={cn('input_checkbox_text consent', error && 'invalid')}>{children}</span>
			</label>
			{error ? <p className='error-message'>{error}</p> : null}
		</div>
	)
}
